import { useMemo, useRef } from "react";
import { createDebouncedClubLoadOptions } from "../clubSelectApi";

export function useProgramGameClubLoaders() {
	const homeDebouncer = useRef({});
	const awayDebouncer = useRef({});

	// Empty deps intentional: debounce state lives in refs; loaders must stay stable across renders.
	const loadHomeOptions = useMemo(
		() => createDebouncedClubLoadOptions(homeDebouncer),
		[],
	);
	const loadAwayOptions = useMemo(
		() => createDebouncedClubLoadOptions(awayDebouncer),
		[],
	);

	return { loadHomeOptions, loadAwayOptions };
}
